import api from './api'
import type { Parceiro, ParceiroRequest, ParceiroResumo } from '@/types/parceiro'

/**
 * Cadastro de parceiros pelo back-office (A12, Onda 7.1). A leitura de catálogo usada
 * pelas telas de produto/oportunidade continua em `produtoService.parceiroService`;
 * aqui entra o que só o administrador faz: listar com inativos, criar, editar, status.
 * O interceptor de `api` já devolve o corpo da resposta.
 */
const BASE_URL = '/api/v1/parceiros'

export const parceirosService = {
  /** `apenasAtivos=false` traz os desativados — a tabela do administrador mostra todos. */
  listar: async (apenasAtivos = false): Promise<Parceiro[]> => {
    const lista = await api.get<Parceiro[]>(`${BASE_URL}?apenasAtivos=${apenasAtivos}`)
    return (lista as unknown as Parceiro[]) ?? []
  },

  resumo: async (): Promise<ParceiroResumo> => {
    return (await api.get<ParceiroResumo>(`${BASE_URL}/resumo`)) as unknown as ParceiroResumo
  },

  criar: async (request: ParceiroRequest): Promise<Parceiro> => {
    return (await api.post<Parceiro>(BASE_URL, request)) as unknown as Parceiro
  },

  atualizar: async (id: string, request: ParceiroRequest): Promise<Parceiro> => {
    return (await api.put<Parceiro>(`${BASE_URL}/${id}`, request)) as unknown as Parceiro
  },

  alterarStatus: async (id: string, ativo: boolean): Promise<Parceiro> => {
    return (await api.patch<Parceiro>(`${BASE_URL}/${id}/status`, { ativo })) as unknown as Parceiro
  },
}
